// @flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {classNames} from '../../../../utils/react';
import {TIENDADA_LINKS} from '../../../../constants';
import {useSidebarContext} from '../SidebarContainer';
import analytics from '../../../../analytics';
import {useStoreInfo} from '../../../store/utils';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(1, 1, 0, 1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textDecoration: 'none',
    borderRadius: '.75rem',
    backgroundImage:
      'linear-gradient(white, white), linear-gradient(270deg, #D1FFB1 -9.15%, #E4D6FF 130.13%)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    border: '4px double transparent',
    overflow: 'hidden',
  },
  rootShrink: {
    width: 48,
    height: 48,
    padding: 0,
    margin: '8px auto 0 auto',
    borderRadius: '50%',
  },
  wrap: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: theme.spacing(2, 1),
    background: 'linear-gradient(270deg, #FFFFFF -2.9%, #D1FFB1 150.45%)',
    justifyContent: 'center',
  },
  svg: {
    display: 'block',
    width: '32px',
    height: '32px',
    flexShrink: 0,
  },
  text: {
    color: '#444444',
    fontSize: '14px',
    lineHeight: '15px',
    fontWeight: '400',
    paddingLeft: theme.spacing(1),
  },
  strong: {
    fontWeight: '600',
  },
}));

export default function AdHocServices() {
  const classes = useStyles();
  const {shrink} = useSidebarContext();

  const store = useStoreInfo();

  const handleClick = () => {
    analytics.fireCustomEvent('Ad Hoc Services Clicked', {
      store_id: store.id,
      domain: window.location.hostname,
    });
  };

  return (
    <a
      href={TIENDADA_LINKS.adHocService}
      target="_blank"
      rel="noopener noreferrer"
      className={classNames(classes.root, {
        [classes.rootShrink]: shrink,
      })}
      onClick={handleClick}
    >
      <div className={classes.wrap}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={classes.svg}
        >
          <circle cx="16" cy="16" r="16" fill="white" />
          <mask
            id="mask0_1595_5639"
            style={{maskType: 'alpha'}}
            maskUnits="userSpaceOnUse"
            x="4"
            y="4"
            width="24"
            height="24"
          >
            <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_1595_5639)">
            <path
              d="M9 25C8.45 25 7.97917 24.8042 7.5875 24.4125C7.19583 24.0208 7 23.55 7 23V9C7 8.45 7.19583 7.97917 7.5875 7.5875C7.97917 7.19583 8.45 7 9 7H18V9H9V23H23V14H25V23C25 23.55 24.8042 24.0208 24.4125 24.4125C24.0208 24.8042 23.55 25 23 25H9ZM11 21H13V14H11V21ZM15 21H17V11H15V21ZM19 21H21V17H19V21ZM21 13V11H19V9H21V7H23V9H25V11H23V13H21Z"
              fill="url(#paint0_linear_1595_5639)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1595_5639"
              x1="1.5"
              y1="4.5"
              x2="36"
              y2="32.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D1FFB1" />
              <stop offset="1" stopColor="#124953" />
            </linearGradient>
          </defs>
        </svg>
        {!shrink && (
          <Typography className={classes.text}>
            ¡Potencia tu negocio con{' '}
            <span className={classes.strong}>nuevos servicios</span> para ti!
          </Typography>
        )}
      </div>
    </a>
  );
}
